import "./index.less";

import mainHeader from "./headers/main-header/index.js";
import mainNav from "./main-nav.js";

const deps = [mainHeader, mainNav];

export default angular.module("vesl.layout", deps).name;
